import { Injectable, OnDestroy } from "@angular/core";
import { LocalStorageService } from "ngx-webstorage";
import { Subscription } from 'rxjs/internal/Subscription';
import { AuthService } from "./auth.service";
import { BroadcastService } from '../modules/tcm-core.module';
import { BroadCastEvents } from '../common/broad-cast-events.enum';
import { MenuMainNode } from "../components/menu/configurations/nodes";

@Injectable({
    providedIn: 'root'
})
export class UserClinicService implements OnDestroy {
    private readonly clinicIdKey = 'ClinicId';

    private userSubscription: Subscription;

    openedMainNode: MenuMainNode;
    workQueueAreaPermissionKeyName = 'workQueue';

    constructor(
        private readonly authService: AuthService,
        private readonly broadcastService: BroadcastService,
        private readonly localStorageService: LocalStorageService
    ) {
        this.userSubscription = this.authService.currentUser$.subscribe(user => {
            if (!user) {
                // Remove the user-selected clinic
                // The user-selected clinic will be reset to the user's Home Clinic in the new session
                this.setClinicIdToLocalStorage(null);
            }
        });
    }

    ngOnDestroy(): void {
        this.userSubscription.unsubscribe();
    }

    get clinicId(): number {
        return this.getClinicIdFromLocalStorage() || (this.authService.currentUserValue ? this.authService.currentUserValue.defaultClinicId : null);
    }

    set clinicId(value: number) {
        this.setClinicIdToLocalStorage(value);
    }

    private getClinicIdFromLocalStorage(): number {
        return this.localStorageService.retrieve(this.clinicIdKey);
    }

    private setClinicIdToLocalStorage(value: number) {
        if (value) {
            this.localStorageService.store(this.clinicIdKey, value);
            this.broadcastService.next({ name: BroadCastEvents.UserClinicChanged, args: { clinicId: this.clinicIdKey } });
            if(this.openedMainNode.areaPermissionKey==this.workQueueAreaPermissionKeyName){
                this.broadcastService.next({ name: BroadCastEvents.NoteChanged });
                this.broadcastService.next({ name: BroadCastEvents.WorkQueueTouched });
            }
        } else {
            this.localStorageService.clear(this.clinicIdKey);
        }


    }
}
